/**
 * Read the JWT `sub` claim from the active access token (session cache or localStorage).
 * Used to detect Redux Persist user id drift vs the live Supabase session.
 */
export function getAccessTokenSubject() {
    if (typeof window === 'undefined') {
        return null;
    }
    const token = localStorage.getItem('access_token');
    if (!token || token === 'undefined' || token === 'null') {
        return null;
    }
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const sub = payload?.sub;
        return typeof sub === 'string' && sub.length > 0 ? sub : null;
    }
    catch {
        return null;
    }
}
/**
 * True when Redux auth user id matches the JWT subject (or when no token is available yet).
 */
export function isReduxUserAlignedWithSession(reduxUserId) {
    if (!reduxUserId) {
        return false;
    }
    const sessionSub = getAccessTokenSubject();
    if (!sessionSub) {
        return true;
    }
    return reduxUserId === sessionSub;
}
